<template>
  <div style="width:100%">
    <div class="activityDrawListSearch timeWidth">
      <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForms searchFormPaddings"
          >
            <el-form-item label="會員帳號" class="searchItem">
              <el-input
                placeholder="请输入會員帳號"
                v-model="listMenuForm.userEmail"
              ></el-input>
            </el-form-item>
            <!-- v-if="shouldlarge" -->
            <el-form-item label="地區" class="searchItem">
              <el-select
                v-model="listMenuForm.selectArea"
                placeholder="请选择地區"
                @change="selectAreaChange"
              >
                <el-option
                  v-for="item in Areaoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- v-if="shouldlarge" -->
            <el-form-item
              label="詳細地區"
              v-if="listMenuForm.selectArea"
              class="searchItem"
            >
              <el-input
                v-model="listMenuForm.areaDetail"
                placeholder="請輸入詳細地址，如上海"
              ></el-input>
            </el-form-item>
            <el-form-item label="VIP開始日期早于" class="searchItems">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time1"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="VIP開始日期晚于"
              class="searchItems"
              v-if="showchange && !listMenuForm.selectArea"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time2"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="黑名單" class="searchItem" v-if="shouldlarge">
              <el-select
                v-model="listMenuForm.isBlack"
                placeholder="請選擇是否為黑名單"
              >
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchFormtwo">
            <el-form-item
              label="VIP開始日期晚于"
              class="searchItems"
              v-if="!showchange || listMenuForm.selectArea"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time2"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="黑名單" class="searchItem" v-if="!shouldlarge">
              <el-select
                v-model="listMenuForm.isBlack"
                placeholder="請選擇是否為黑名單"
              >
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="index == 0 ? '徽章' : ''"
              class="searchItem searchbage"
              v-for="(badges, index) in listMenuForm.badge"
              :key="index"
            >
              <el-select
                v-model="badges.badgeType"
                placeholder="請選擇徽章"
                @change="BadgeoptionsChange(badges.badgeType, index)"
              >
                <el-option
                  v-for="item in Badgeoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="badges.badgeLevel"
                placeholder="請選擇徽章等級"
                style="margin-left:10px"
              >
                <el-option
                  v-for="item in BadgeLeveloptions[index]"
                  :key="item.id"
                  :label="item.grade"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span
                v-show="!(index === 0)"
                style="color:#6C3DEA; cursor: pointer;"
                @click="
                  delGoodsItem(index, listMenuForm.badge, BadgeLeveloptions)
                "
                >删除</span
              >
              <i
                v-if="index === listMenuForm.badge.length - 1"
                class="el-icon-circle-plus-outline"
                @click="addbadges()"
              ></i>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="MenuBtnWrap_right" style="margin-right:16px">
        <div class="btn" @click="search()" style="marginRight:0.2rem">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
    </div>
    <div class="activityDrawListTable">
      <div class="statusbar">
        <div class="statusbar_left" v-if="this.paymessage.applyStatus == 4">
          <div>已選擇（跨頁）</div>
          <div style="color:rgba(108, 61, 234, 1)">
            {{ checkboxList.length }} 項
          </div>
        </div>
        <div class="statusbar_left" v-else></div>
        <div class="statusbar_right">
          <div
            class="btn btnPur"
            v-if="
              (!secondWave && this.paymessage.applyStatus == 4) ||
                this.paymessage.free == 0
            "
            @click="handchangelist('win')"
          >
            更新為已抽中
          </div>
          <div
            class="btn btnPur"
            @click="handleDownloadExcel"
            style="margin-left: 25px;"
          >
            下載未中选名單
          </div>
          <div
            class="btn"
            @click="handleregenerateshow('again')"
            style="margin-left: 25px;"
            v-if="!secondWave && this.paymessage.applyStatus == 5"
          >
            再次生成活動
          </div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          height="660px"
          :data="tableData"
          style="width: 100%"
          :row-key="row => row.id"
          @select="handleSelect"
          @select-all="selectAll"
          @sort-change="handleSortChange"
          stripe
        >
          <template slot="empty">
            <div class="no-data-container" style="width:80vw">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            type="selection"
            width="55"
            v-if="this.paymessage.free == 0 || this.paymessage.applyStatus == 4"
          >
          </el-table-column>
          <el-table-column
            v-for="(item, index) in activityTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :sortable="item.sortable"
            
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop === 'status'">
                <div v-if="scope.row.status == 0">待抽籤</div>
                <div v-else-if="scope.row.status == 1">未付款</div>
                <div v-else-if="scope.row.status == 2">未抽中</div>
                <div v-else-if="scope.row.status == 3">已付款</div>
                <div v-else-if="scope.row.status == 4">已取消</div>
                <div v-else-if="scope.row.status == 5">已過期</div>
                <div
                  v-else-if="scope.row.status == 6"
                  style="color:rgb(108, 61, 234)"
                >
                  已抽中
                </div>
                <div v-else>-</div>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button @click="navigatetoDetail(scope.row)" type="text"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="20"
          :page-sizes="[20, 50, 100, 200]"
          :pager-count="5"
          layout="sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示訊息"
      :visible.sync="regenerateshow"
      width="5.6rem"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="closeModal"
    >
      <div style="text-align:left" v-if="showtype == 'again'">
        <div class="commonfont">是否生成{{ confirmTitle }}活動？</div>
        <div class="commonfont" style="marginTop:30px">
          <span class="commonfont">開放報名時間：</span>
          <el-date-picker
            v-model="startTime"
            type="datetime"
            placeholder="選擇時間"
          ></el-date-picker>
        </div>
        <div style="marginTop:30px" class="commonfont">
          <span class="commonfont">報名結束時間：</span>
          <el-date-picker
            v-model="endTime"
            type="datetime"
            placeholder="選擇時間"
          ></el-date-picker>
        </div>
        <div style="marginTop:30px;color:rgba(147, 142, 164, 1)">
          生成後可在活動可在用户端直接查看，也可在列表中進行編輯及抽籤
        </div>
        <div
          style="marginTop:30px;display:flex;align-items:center"
          class="commonfont"
        >
          <el-switch active-color="#6C3DEA" v-model="ispush"> </el-switch>
          <span style="margin-left:5px;color:#6C3DEA" class="commonfont">
            推送给用户
          </span>
        </div>
      </div>
      <div v-if="showtype == 'win'">
        <div class="commonfont" style="font-weight: 500;">
          當前已抽中人數：{{ this.checkboxList.length }}人
        </div>
        <div v-if="this.paymessage.free == 1" style="margin-top: 10px;">
          <span
            style="font-weight: 500;font-size: 14px;display: inline-block;margin-right: 15px;"
            class="commonfont"
            >請選擇付款結束時間</span
          >
          <el-date-picker
            v-model="paytime"
            type="datetime"
            placeholder="請選擇付款結束時間"
          >
          </el-date-picker>
        </div>
        <div
          v-if="this.paymessage.free == 1"
          style="margin-top: 15px;"
          class="commonfont"
        >
          更新活動將進入確認階段並且無法在修改。 是否更新所有的報名狀態？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="regenerateshow = false">取消</el-button>
        <el-button type="primary" @click="blackaddshowModal">{{
          this.showtype === "again" ? "確認生成" : "確認更新"
        }}</el-button>
      </span>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "活動 / 活動列表 ",
      navtitle: "活動抽簽",
      showtype: "",
      listMenuForm: {
        userEmail: "",
        time1: "",
        time2: "",
        badge: [
          {
            badgeLevel: "",
            badgeType: ""
          }
        ],
        selectStatus: "",
        selectArea: "",
        areaDetail: "",
        isBlack: ""
      },
      dialogVisible: false,
      currentPage: 1, // 分页
      total: 10,
      currentPageSize: 20,
      regenerateshow: false,
      startTime: "", //黑名单截止时间
      endTime: "", //黑名单原因
      ispush: true,
      showTip: "",
      shouldlarge: true,
      secondWave: "",
      activityTable: [
        {
          prop: "status",
          label: "報名狀態",
          width: "170"
        },
        {
          prop: "username",
          label: "會員帳號",
          width: "170"
        },
        {
          prop: "applicant",
          label: "申請人",
          width: "170"
        },
        {
          prop: "num",
          label: "張數",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "district",
          label: "地區",
          width: "170"
        },
        {
          prop: "vipStartTime",
          label: "VIP起始日",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "vipEndTime",
          label: "VIP到期日",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "annualSelectNum",
          label: "本年度中選次數",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "sameTypeSelectNum",
          label: "同類型中選次數",
          width: "150",
          sortable: "custom"
        },
        {
          prop: "remark",
          label: "報名備註",
          width: "250"
        }
      ],
      //地区选择框
      Areaoptions: [
        {
          value: "1",
          label: "中國大陸"
        },
        {
          value: "2",
          label: "港澳臺"
        },
        {
          value: "3",
          label: "海外"
        }
      ],
      //徽章选择框
      Badgeoptions: [],
      BadgeLeveloptions: [{}],
      BadgeoptionsSum: [],
      tableData: [],
      isActivate: false, //详情缓存，非详情手刷
      sortType: "",
      sortValue: "",
      confirmTitle: "",
      showchange: true,
      checkboxList: [], //所有页面选中编号
      paymessage: {},
      paytime: ""
    };
  },
  created() {
    this.initpage();
    //手动清除整个页面，从列表处打开需要触发
    this.$bus.$on("activityDrawConfirminitNull", () => {
      Object.assign(this.$data, this.$options.data());
      this.isActivate = false;
      this.initpage();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  destroyed() {},
  activated() {
    if (this.isActivate) {
      this.initpage();
    }
  },
  deactivated() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    closeModal() {
      this.paytime = "";
    },
    // 更新为已抽中
    handchangelist(type) {
      this.showtype = type;
      if (type == "win" && this.checkboxList.length == 0) {
        // this.regenerateshow = false;

        this.dialogVisible = true;
        this.$propMessage("請選擇更新用戶", "error", () => {
          this.dialogVisible = false;
        });
      } else {
        this.regenerateshow = true;
      }
    },
    //跨页选择未选中
    handleSelect(selection, row) {
      //选中行长度大于0并且当前行在选中行中 checkedTrue为true
      let checkedTrue = selection.length && selection.indexOf(row) !== -1;
      if (!checkedTrue) {
        // 取消勾选,使用filter()方法过滤掉刚刚勾选的那一条数据
        this.checkboxList = this.checkboxList.filter(item => item.id != row.id);
      }
      if (checkedTrue) {
        // 勾选，将刚刚勾选的数据用push()方法放进数组
        this.checkboxList.push(row);
      }
    },
    // 全选
    selectAll(selection) {
      // selection 为当前页面的勾选数组
      if (selection.length > 0) {
        // 全选，将本页面所有（可以勾选的）数据放入自定义的勾选数组里
        const uniqueArray = selection.filter(item1 => {
          return !this.checkboxList.some(item2 => item2.id === item1.id);
        });
        this.checkboxList.push(...uniqueArray);
      } else {
        // 取消全选，将本页面所有（可以勾选的）数据用filter()＋every()方法过滤掉
        this.checkboxList = this.checkboxList.filter(
          item => this.tableData.every(it => it.id != item.id)
          // every方法，数组里面所有数据为真则返回真
        );
      }
    },
    delGoodsItem(index, list, list2) {
      list.splice(index, 1);
      list2.splice(index, 1);
    },
    addbadges() {
      const _this = this;
      let length = _this.listMenuForm.badge.length;
      _this.listMenuForm.badge.push({
        badgeLevel: "",
        badgeType: ""
      });
    },
    initpage() {
      // this.BadgeInit()
      this.getList();
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    },
    selectAreaChange(item) {
      this.listMenuForm.areaDetail = "";
    },
    handleResize() {
      let a =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.shouldlarge = a > 1919;
      this.showchange = a > 1500;
    },
    //徽章处理
    BadgeInit() {
      this.$get("/request/badge/all").then(res => {
        if (res.code == "00000") {
          this.BadgeoptionsSum = res.data;
          let current = [];
          res.data.forEach(item => {
            current.push({ label: item.name, value: item.name });
          });
          this.Badgeoptions = current;
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    getList() {
      let _this = this;
      let param = {
        applyId: this.$route.query.id,
        status: 0
      };
      if (_this.listMenuForm.userEmail) {
        param = {
          ...param,
          username: _this.listMenuForm.userEmail
        };
      }
      // 開始時間
      if (_this.listMenuForm.time1) {
        let startTime = this.$formatDate(_this.listMenuForm.time1);
        param = {
          ...param,
          vipStartTime: startTime
        };
      }
      // 結束時間
      if (_this.listMenuForm.time2) {
        let endTime = this.$formatDate(_this.listMenuForm.time2);
        param = {
          ...param,
          vipEndTime: endTime
        };
      }
      let badgeId = [];
      if (_this.listMenuForm.badge[0].badgeType) {
        for (let i = 0; i < _this.listMenuForm.badge.length; i++) {
          if (!_this.listMenuForm.badge[i].badgeLevel) {
            this.dialogVisible = true;
            this.$propMessage("選擇徽章後請選擇徽章等級", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else {
            badgeId.push(_this.listMenuForm.badge[i].badgeLevel);
            param = {
              ...param,
              badgeId: badgeId.toString()
            };
          }
        }
      }
      if (_this.listMenuForm.selectArea) {
        param = {
          ...param,
          district: Number(_this.listMenuForm.selectArea),
          address: _this.listMenuForm.areaDetail
            ? _this.listMenuForm.areaDetail
            : null
        };
      }
      if (_this.listMenuForm.isBlack) {
        param = {
          ...param,
          blackList: Number(_this.listMenuForm.isBlack)
        };
      }
      if (_this.sortValue !== "") {
        param = {
          ...param,
          [_this.sortType]: _this.sortValue
        };
      }
      _this
        .$post(
          `/request/apply/confirm/list?page=${_this.currentPage}&size=${_this.currentPageSize}`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.total = res.data.allRow;
            _this.tableData = res.data.list;
            _this.secondWave = res.data.secondWave;
            _this.confirmTitle = res.data.applyName + "（第二波）";
            _this.paymessage.free = res.data.free;
            _this.paymessage.land = res.data.land;
            _this.paymessage.price = res.data.price;
            _this.paymessage.twdPrice = res.data.twdPrice;
            _this.paymessage.applyStatus = res.data.applyStatus;
            _this.paymessage.beSelectedNumber = res.data.beSelectedNumber;
            this.$emit("dataBack", {
              applyName: res.data.applyName,
              applyWay: res.data.applyWay,
              applyStatus: res.data.applyStatus,
              registration: res.data.registration,
              totalNum: res.data.totalNum,
              beSelectedNumber: res.data.beSelectedNumber,
              notSelectedNumber: res.data.notSelectedNumber,
              free: res.data.free,
              land: res.data.land
            });
            if (!_this.BadgeoptionsSum.length) {
              _this.BadgeInit();
            }
          } else {
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
          }
        });
    },
    BadgeoptionsChange(item) {
      let currentlist = [];
      this.BadgeoptionsSum.map(ite => {
        if (ite.name == item) currentlist = ite.detailDtoList;
      });
      this.BadgeLeveloptions[index] = currentlist;
      this.listMenuForm.badge[index].badgeLevel = "";
    },
    search() {
      this.getList();
    },
    reset() {
      this.listMenuForm = {
        userEmail: "",
        time1: "",
        time2: "",
        badge: [
          {
            badgeLevel: "",
            badgeType: ""
          }
        ],
        selectStatus: "",
        selectArea: "",
        areaDetail: "",
        isBlack: ""
      };
      this.BadgeLeveloptions = [{}];
      this.getList();
    },
    navigatetoDetail(item) {
      this.isActivate = true;
      this.$router.push(`/activityDrawDetail?id=${item.id}&isconfirm=1`);
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.getList();
    },

    //确认黑名单
    blackaddshowModal() {
      let _this = this;
      if (_this.showtype === "again") {
        if (_this.startTime == "") {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇開放報名時間：", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (_this.endTime == "") {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇報名結束時間：：", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
        // let timeFormatS = _this.$compareTime(_this.startTime, new Date());
        // if(!timeFormatS){
        //     _this.dialogVisible = true;
        //     _this.$propMessage('開放報名時間不可以晚於當前時間', 'error', function () {
        //         _this.dialogVisible = false;
        //     });
        //     return false
        // }
        let timeFormatE = _this.$compareTime(_this.endTime, new Date());
        if (!timeFormatE) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "報名結束時間不可以晚於當前時間",
            "error",
            function() {
              _this.dialogVisible = false;
            }
          );
          return false;
        }
        let timeFormatL = _this.$compareTime(_this.endTime, _this.startTime);
        if (!timeFormatL) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "開放報名時間不可以晚於報名結束時間",
            "error",
            function() {
              _this.dialogVisible = false;
            }
          );
          return false;
        }
        let startTime, endTime;
        if (_this.startTime === "" || _this.startTime === null) {
          startTime = null;
        } else {
          startTime = _this.$formatDate(_this.startTime);
        }
        if (_this.endTime === "" || _this.endTime === null) {
          endTime = null;
        } else {
          endTime = _this.$formatDate(_this.endTime);
        }
        let param = {
          applyId: _this.$route.query.id,
          startTime: startTime,
          endTime: endTime,
          push: _this.ispush ? 1 : 0
        };
        _this
          .$post(
            `/request/apply/generate/second/wave/activity`,
            param,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            if (res.code == "00000") {
              _this.dialogVisible = true;
              _this.$propMessage("第二波活動已生成成功", "success", () => {
                _this.dialogVisible = false;
                _this.regenerateshow = false;
                _this.$router.push(`/activityList`);
              });
            } else {
              _this.dialogVisible = true;
              _this.$propMessage(res.message, "error", () => {
                _this.dialogVisible = false;
              });
            }
          });
      } else if (_this.showtype == "win") {
        if (_this.checkboxList.length == 0) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇更新用戶", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else if (_this.paytime == "" && _this.paymessage.free == 1) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇付款結束時間", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          let list = [];
          let param = {
            applyId: "",
            activityIdList: [],
            orderOutTime: ""
          };
          _this.checkboxList.forEach(item => {
            list.push(item.id);
          });
          if (_this.paymessage.free == 1) {
            (param.applyId = _this.$route.query.id),
              (param.activityIdList = list),
              (param.orderOutTime = _this.$getTime(_this.paytime));
          } else {
            (param.applyId = _this.$route.query.id),
              (param.activityIdList = list);
          }
          _this
            .$post(
              `/request/apply/update/selected`,
              param,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              if (res.code == "00000") {
                _this.regenerateshow = false;
                _this.dialogVisible = true;
                _this.$propMessage("更新状态成功", "success", () => {
                  _this.checkboxList = [];
                  _this.getList();
                  _this.dialogVisible = false;
                });
              } else {
                _this.dialogVisible = true;
                _this.$propMessage(res.message, "error", () => {
                  // _this.checkboxList = [];
                  // _this.getList();
                  _this.dialogVisible = false;
                });
              }
            });
        }
      }
    },
    //需要跨页全排，前端做不了要后端支持
    handleSortChange({ column, prop, order }) {
      if (prop == "num") {
        this.sortType = "numOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "vipStartTime") {
        this.sortType = "vipStartTimeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "vipEndTime") {
        this.sortType = "vipEndTimeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "annualSelectNum") {
        this.sortType = "annualOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "sameTypeSelectNum") {
        this.sortType = "sameTypeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      }
      setTimeout(() => {
        this.getList();
      }, 50);
    },
    handleregenerateshow(type) {
      (this.startTime = ""),
        (this.endTime = ""),
        (this.ispush = true),
        (this.regenerateshow = true),
        (this.showtype = type);
    },
    handleDownloadExcel() {
      let _this = this;
      let param = {
        applyId: this.$route.query.id,
        status: 0
      };
      if (_this.listMenuForm.userEmail) {
        param = {
          ...param,
          username: _this.listMenuForm.userEmail
        };
      }
      if (_this.listMenuForm.time1 && _this.listMenuForm.time2) {
        let startTime = this.$formatDate(_this.listMenuForm.time1);
        let endTime = this.$formatDate(_this.listMenuForm.time2);
        param = {
          ...param,
          vipStartTime: startTime,
          vipEndTime: endTime
        };
      }
      let badgeId = [];
      if (_this.listMenuForm.badge[0].badgeType) {
        for (let i = 0; i < _this.listMenuForm.badge.length; i++) {
          if (!_this.listMenuForm.badge[i].badgeLevel) {
            this.dialogVisible = true;
            this.$propMessage("選擇徽章後請選擇徽章等級", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else {
            badgeId.push(_this.listMenuForm.badge[i].badgeLevel);
            param = {
              ...param,
              badgeId: badgeId.toString()
            };
          }
        }
      }

      if (_this.listMenuForm.selectArea) {
        param = {
          ...param,
          district: Number(_this.listMenuForm.selectArea),
          address: _this.listMenuForm.areaDetail
            ? _this.listMenuForm.areaDetail
            : null
        };
      }
      if (_this.listMenuForm.isBlack) {
        param = {
          ...param,
          blackList: Number(_this.listMenuForm.isBlack)
        };
      }
      if (_this.sortValue !== "") {
        param = {
          ...param,
          [_this.sortType]: _this.sortValue
        };
      }
      let url = "/request/apply/export/excel/status";
      let date = new Date();
      _this.$exportExcel(
        url,
        "POST",
        param,
        "未中選名單" + this.$formatDate(date).substring(0, 10)
      );
    }
  },
  components: {
    DiaMess
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.content {
  .el-icon-circle-plus-outline {
    font-size: 20px;
    cursor: pointer;
  }
  .el-icon-circle-plus-outline::before {
    position: relative;
    top: 2px;
  }
  .paddingContent {
    width: 100%;
    // overflow: auto;
    .activityDrawListSearch {
      width: 100%;
      .ListMenu {
        display: flex;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
        margin-top: 2px;
      }
      .MenuBtnWrap_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .activityDrawListTag {
      background: rgba(250, 250, 253, 1);
      display: flex;
      align-items: center;
      padding: 16px;
      border-radius: 5px;
      margin-top: 26px;
      .activityDrawListTag_detail_key {
        margin-left: 24px;
        font-size: 14px;
        color: rgba(147, 142, 164, 1);
      }
      .activityDrawListTag_detail_value {
        font-size: 17px;
        color: rgba(41, 41, 41, 1);
      }
    }
    .statusbar_top {
      font-size: 14px;
      color: #000;
      font-weight: 500;
      margin-left: 25px;
    }
    .activityDrawListTable {
      border-radius: 5px;
      margin-top: 10px;
      .statusbar {
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .statusbar_left {
          display: flex;
          align-items: center;
          div {
            font-size: 14px;
          }
          div:nth-child(1) {
            color: rgba(41, 41, 41, 1);
          }
        }
        .statusbar_right {
          display: flex;
          align-items: center;
          .btnPur {
            background: none;
            color: rgba(105, 62, 221, 1);
            border: 1px solid rgba(105, 62, 221, 1);
            // margin-right: 20px;
          }
        }
      }
    }
    .remark_box_input {
      position: relative;
      margin-top: 30px;
    }
    .remark_box_text {
      position: absolute;
      z-index: 10;
      // color: #292929;
      left: 20px;
      line-height: 46px;
      // font-size: 0.14rem;
    }
  }
}
/deep/ .el-textarea__inner {
  text-indent: 50px;
}
/deep/ .el-dialog {
  border-radius: 12px;
}
// /deep/ .el-dialog__header {
//   //   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
// }
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
.dialog {
  display: flex;
  justify-content: center;
  .el-upload__tip {
    color: #65676b;
  }
  .dialogrow {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/ .el-checkbox {
      width: 110px !important;
      text-align: left;
      display: block !important;
    }
    /deep/ .el-input {
      width: 190px !important;
    }
    .badgeadd {
      width: 80px;
      color: rgba(147, 144, 163, 1);
      background: rgba(242, 240, 247, 1);
      text-align: center;
      cursor: pointer;
      line-height: 36px;
      margin-left: 9px;
      border-radius: 6px;
    }
    .badgedelete {
      width: 80px;
      text-align: center;
      color: #6c3dea;
      line-height: 36px;
      margin-left: 9px;
      cursor: pointer;
    }
  }
  .btngroup {
    margin-top: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      text-align: center;
    }
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityConfirmNull.vue